import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw44Handlers = [
  // ページテンプレート選択項目取得 /kymw44/getPageTemplateSelectItems
  http.post(
    PlessService.SERVICE.getPageTemplateSelectItems.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getPageTemplateSelectItemsResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // ユーザ管理選択項目取得 /kymw44/getUserManagementSelectItems
  http.post(
    PlessService.SERVICE.getUserManagementSelectItems.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getUserManagementSelectItemsResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 特集情報選択項目取得 /kymw44/getFeatureThemaSelectItems
  http.post(
    PlessService.SERVICE.getFeatureThemaSelectItems.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getFeatureThemaSelectItemsResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載商品グループ選択項目取得 /kymw44/getPublishGoodsGroupSelectItems
  http.post(
    PlessService.SERVICE.getPublishGoodsGroupSelectItems.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getPublishGoodsGroupSelectItemsResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // ページ一覧取得 /kymw44/getPageInfoList
  http.post(PlessService.SERVICE.getPageInfoList.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(getPageInfoListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // ページ一覧登録 /kymw44/registPageInfoList
  http.post(
    PlessService.SERVICE.registPageInfoList.url,
    async ({ request }) => {
      const req = await request;
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // ページ情報コピー /kymw44/copyPageInfo
  http.post(PlessService.SERVICE.copyPageInfo.url, async ({ request }) => {
    const req = await request;
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
    // return HttpResponse.json({
    //   status: 'plessError',
    //   message: '既に企画確定されているため更新できません。',
    //   errorcode: 'E0518',
    //   strings: [],
    // });
  }),

  // 生協間ページ情報コピー /kymw44/copyPageInfoToCoops
  http.post(
    PlessService.SERVICE.copyPageInfoToCoops.url,
    async ({ request }) => {
      const req = await request;
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
      // return HttpResponse.json({
      //   status: 'plessError',
      //   message: '既に企画確定されているため更新できません。',
      //   errorcode: 'E0518',
      //   strings: [],
      // });
    }
  ),

  // ページ情報CSV出力 /kymw44/outputPageInfoCsv
  http.post(PlessService.SERVICE.outputPageInfoCsv.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(outputPageInfoCsvResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 自動コマ配置 /kymw44/registAutoKomaArrange
  http.post(
    PlessService.SERVICE.registAutoKomaArrange.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(registAutoKomaArrangeResponse2);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  http.post(
    PlessService.SERVICE.getAutoKomaArrangePatternList.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getAutoKomaArrangePatternListResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
];

const getPageTemplateSelectItemsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        Code: '1',
        Name: '食品（５×７）',
      },
      {
        Code: '2',
        Name: '酒（７×６）',
      },
    ],
  },
};
const getUserManagementSelectItemsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        Code: 'usr001',
        Name: 'ユーザ１',
      },
      {
        Code: 'usr002',
        Name: 'ユーザ２',
      },
      {
        Code: 'usr003',
        Name: 'ユーザ３',
      },
    ],
  },
};
const getFeatureThemaSelectItemsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        Code: '00001',
        Name: '特集１',
      },
      {
        Code: '00002',
        Name: '特集２',
      },
      {
        Code: '00003',
        Name: '特集３',
      },
    ],
  },
};
const getPublishGoodsGroupSelectItemsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        Code: '1',
        Name: '飲料１',
      },
      {
        Code: '2',
        Name: '飲料２',
      },
      {
        Code: '3',
        Name: '飲料３',
      },
      {
        Code: '4',
        Name: '飲料４',
      },
      {
        Code: '5',
        Name: '最大文字数５０文字＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞ＥＮＤ',
      },
    ],
  },
};
const getPageInfoListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      PlanFixed: '0',
      OriginalOrderCode: "2020010",
      OriginalCoopCode: "210:さいたまコープ",
      PageList: [
        {
          PageId: '1',
          PageNum: '1',
          Folio: '1',
          PageInfo: '表紙：中華特集',
          WebCatalogTitle: '特集',
          PageTemplateId: '1',
          ContactUser1: 'usr001',
          ContactUser2: 'usr003',
          ContactUser3: '',
          Feature1: '00001',
          Feature2: '00002',
          Feature3: '00003',
          // AutoArrangePattern: '001',
          AutoArrangePattern: '003',
          CommonPublishFlg: '0',
          PublishGoodsGroupIdList: ['1', '2', '3', '4', '5', '6'],
          TagIdList: [
            '00000001',
            '00000002',
            '00000003',
            '00000004',
            '00000005',
          ],
        },
        {
          PageId: '2',
          PageNum: '2',
          Folio: '2',
          PageInfo: '特集 アイス・涼味デザート',
          WebCatalogTitle: '特集',
          PageTemplateId: '2',
          ContactUser1: 'usr002',
          ContactUser2: 'usr003',
          ContactUser3: 'usr001',
          Feature1: '00001',
          Feature2: '00002',
          Feature3: '00003',
          AutoArrangePattern: '',
          CommonPublishFlg: '1',
          PublishGoodsGroupIdList: ['1'],
          TagIdList: ['00000003', '00000004'],
        },
        {
          PageId: '3',
          PageNum: '3',
          Folio: '3',
          PageInfo: '特集 アイス・涼味デザート',
          WebCatalogTitle: '特集',
          PageTemplateId: '',
          ContactUser1: 'usr002',
          ContactUser2: 'usr003',
          ContactUser3: '',
          Feature1: '00001',
          Feature2: '00002',
          Feature3: '',
          AutoArrangePattern: '',
          CommonPublishFlg: '1',
          PublishGoodsGroupIdList: ['3', '4'],
          TagIdList: ['00000003', '00000004'],
        },
        {
          PageId: '4',
          PageNum: '4',
          Folio: '4',
          PageInfo:
            '最大文字数２５文字＞＞＞＞＞＞＞＞＞＞＞＞＞ＥＮＤ',
          WebCatalogTitle: '最大文字数２５文字＞＞＞＞＞＞＞＞＞＞＞＞＞ＥＮＤ',
          PageTemplateId: null,
          ContactUser1: 'usr002',
          ContactUser2: 'usr003',
          ContactUser3: '',
          Feature1: '00001',
          Feature2: '00002',
          Feature3: '',
          AutoArrangePattern: null,
          CommonPublishFlg: '1',
          PublishGoodsGroupIdList: [],
          TagIdList: [],
        },
      ],
    },
  },
};

const outputPageInfoCsvResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      FileName:
        '/tmp/peace/data/WebData/downloadtemp/KYMW4400_001_2023160_142_20240814_161931.csv',
    },
  },
};

const registAutoKomaArrangeResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "MsgId": "W0054",
      "PageNumText": "3"
    }
  }
}

const registAutoKomaArrangeResponse2 = {
  "status": "plessError",
  "message": "自動コマ割のコピー元となる受注コード・生協コードが登録されていないページがあります。\nページ番号:3",
  "errorcode": "E0603",
  "strings": [
    "3"
  ]
}

const getAutoKomaArrangePatternListResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp204",
        "CodeValue": "001",
        "CodeName": "ハピデリ中面",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp204",
        "CodeValue": "003",
        "CodeName": "前回コピー",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}
